<div class="input-container !mb-0" *ngIf="data$ | async as data">
  <span class="form-control-label">
    {{ (data.isRequired ? '* ' : '') + label }}
  </span>

  <div class="dropdown-wrapper" [ngClass]="{ open: dropdownOpen }">
    <div
      class="dropdown-header select"
      (click)="toggleDropdown()"
      [ngClass]="{
        'border-red-error':
          data.isTouched && data.errors && data.errors['required']
      }"
    >
      <span class="flex justify-between w-full" *ngIf="getSelectedText(); else placeholder">
        {{ getSelectedText() }}
        <fa-icon *ngIf="clearValueEnabled && !selectControl.disabled" (click)="clearSelection()" [icon]="faXmark"></fa-icon>
      </span>

      <ng-template #placeholder>
        {{ nullText }}
      </ng-template>
    </div>

    <div class="dropdown-body rounded" *ngIf="dropdownOpen">
      <input
        type="text"
        class="search-input"
        placeholder="Search..."
        [formControl]="searchControl"
      />

      <div
        class="option"
        *ngFor="let option of filteredOptions"
        (click)="selectOption(option)"
      >
        {{ option.text }}
      </div>
    </div>
  </div>

  <span class="tooltip" [attr.data-tip]="tooltip">
    <fa-icon
      *ngIf="!removeExclamationIcon"
      [icon]="faCircleInfo"
      class="text-2xl text-dark-40 ml-4"
      [class.invisible]="hideExclamationIcon"
    ></fa-icon>
  </span>
</div>
